import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getApiBaseUrl } from '../utils/axios';
import PageMeta from './PageMeta';
import './Blog.css';

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError(false);
    fetch(`${getApiBaseUrl()}/api/cms/pages/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(data => setPage(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-layout">
        <header className="blog-header">
          <div className="blog-header-inner">
            <Link to="/welkom" className="blog-logo-link">
              <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
            </Link>
            <nav className="blog-nav">
              <Link to="/welkom">Home</Link>
              <Link to="/blog">Blog</Link>
            </nav>
          </div>
        </header>
        <main className="blog-main">
          <div className="blog-container"><p className="blog-loading">Laden...</p></div>
        </main>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="blog-layout">
        <header className="blog-header">
          <div className="blog-header-inner">
            <Link to="/welkom" className="blog-logo-link">
              <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
            </Link>
            <nav className="blog-nav">
              <Link to="/welkom">Home</Link>
              <Link to="/blog">Blog</Link>
            </nav>
          </div>
        </header>
        <main className="blog-main">
          <div className="blog-container">
            <h1>Pagina niet gevonden</h1>
            <p><Link to="/welkom">Terug naar home</Link></p>
          </div>
        </main>
      </div>
    );
  }

  const seoTitle = page.meta_title || page.title;
  const seoDesc = page.meta_description || page.title;

  return (
    <div className="blog-layout">
      <PageMeta title={seoTitle} description={seoDesc} />
      <header className="blog-header">
        <div className="blog-header-inner">
          <Link to="/welkom" className="blog-logo-link">
            <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
          </Link>
          <nav className="blog-nav">
            <Link to="/welkom">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/welkom#pricing">Prijzen</Link>
            <a href="mailto:support@ploko.nl">Contact</a>
          </nav>
        </div>
      </header>

      <main className="blog-main">
        <div className="blog-container blog-post-container">
          <h1 className="blog-post-title">{page.title}</h1>
          <div
            className="blog-post-body"
            dangerouslySetInnerHTML={{ __html: page.body || '' }}
          />
          <p className="blog-post-back">
            <Link to="/welkom">← Terug naar home</Link>
          </p>
        </div>
      </main>

      <footer className="blog-footer">
        <div className="blog-container">
          <p>
            <Link to="/welkom">OfferteRunner</Link> – Professionele offertes in minuten. Koppeling met Odoo en AI.
          </p>
        </div>
      </footer>
    </div>
  );
}
